<template>
<div class="flex w-full relative">
  <spinner :loading="replyLoading" />
    <!-- tweet section -->
    <section class=" w-1/2 shadow-md p-3 rounded-md mr-2">
     <TweetRenderLeft :tweetInfo="activityInfo[currentTweet]" :handleNextCallback="handleNextTweet" :handlePrevCallback="handlePrevTweet" :isFirst="currentTweet!==0" :isLast="activityInfo.length!==currentTweet+1"  />
    </section>
     <!-- Reply section   -->
     <section class="w-1/2 shadow-md p-3 rounded-md">
       <TweetReply :tweetInfo="activityInfo[currentTweet]" :loadingCallback="handleLoading" :autoLike='autoLike' />
     </section>
</div>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import TweetRenderLeft from './TweetRenderLeft.vue';
import TweetReply from './TweetReply.vue';
import spinner from '@/components/spinner.vue';

export default {
  name: 'TweetRender',
  layout: 'admin',
  store,
  props: ['activityInfo', 'autoLike'],
  data() {
    return {
      currentTweet: 0,
      activityData: [],
      replyLoading: false,
    };
  },
  components: { TweetRenderLeft, TweetReply, spinner },
  mounted() {
    // console.log('i am personal', this.activityInfo);
  },
  watch: {
    activityInfo() {
      this.activityData = this.activityInfo;
      this.currentTweet = 0;
    },
  },
  methods: {
    handleNextTweet() {
      this.currentTweet += 1;
    },
    handlePrevTweet() {
      this.currentTweet -= 1;
    },
    handleLoading(value) {
      this.replyLoading = value;
    },
  },
  filters: {
    moment: (date) => moment(date).fromNow(),
  },
};
</script>
